// store.js

import { createStore } from 'vuex'  // เปลี่ยนจาก import Vuex เป็น createStore

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import authModule from "./module/auth.js";
import usageModule from "./module/usageModule";
import featureModule from "./module/feature";
import subscriptionModule from "./module/subscriptionModule";
import pageModule from "./module/pageModule";


// ไม่ต้องเรียก app.use(Vuex) ที่นี่ ให้ทำใน main.js

export default createStore({
  state,
  getters,
  mutations,
  actions,
  modules: {
    authModule,
    subscriptionModule,
    usageModule,
    featureModule,
    pageModule
  },
  strict: process.env.NODE_ENV !== "production",
});
